(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7057,5664],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Frevision%2F%5Bid%5D.tsx&page=%2Frevision%2F%5Bid%5D!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/revision/[id]",
      function () {
        return __webpack_require__("./src/pages/revision/[id].tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/pages/revision/[id].tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next/router.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _reduxjs_toolkit_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/@reduxjs/toolkit/dist/query/rtk-query.esm.js");
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _services_activities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/services/activities/index.ts");
/* harmony import */ var _store_hook__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/store/hook.ts");
/* harmony import */ var _components_SEO_Wiki__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/components/SEO/Wiki.tsx");
/* harmony import */ var _components_Wiki_WikiPage_WikiMarkup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/components/Wiki/WikiPage/WikiMarkup.tsx");
/* harmony import */ var _services_wikis_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/services/wikis/utils.ts");
/* harmony import */ var _components_Elements__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/components/Elements/index.ts");
/* harmony import */ var _utils_WikiUtils_getWikiImageUrl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");













const Revision = (param)=>{
    let { wiki  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { id: ActivityId  } = router.query;
    const [isTocEmpty, setIsTocEmpty] = react__WEBPACK_IMPORTED_MODULE_1__.useState(true);
    const [isLatest, setIsLatest] = react__WEBPACK_IMPORTED_MODULE_1__.useState(true);
    const toc = (0,_store_hook__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .C)((state)=>state.toc);
    const [wikiData, setWikiData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(wiki);
    const wikiId = (ref = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref === void 0 ? void 0 : ref.id;
    const { data: latestIPFS  } = (0,_services_activities__WEBPACK_IMPORTED_MODULE_4__/* .useGetLatestIPFSByWikiQuery */ .KX)(typeof wikiId === "string" ? wikiId : _reduxjs_toolkit_query__WEBPACK_IMPORTED_MODULE_11__/* .skipToken */ .CN, {
        skip: router.isFallback
    });
    // clear cite marks if any present initially
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        _store_store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch({
            type: "citeMarks/reset"
        });
    }, [
        ActivityId
    ]);
    // check if the current revision is the latest revision
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (latestIPFS && wikiData && latestIPFS !== (wikiData === null || wikiData === void 0 ? void 0 : wikiData.ipfs)) {
            setIsLatest(false);
        } else {
            setIsLatest(true);
        }
    }, [
        latestIPFS,
        wikiData,
        wikiData === null || wikiData === void 0 ? void 0 : wikiData.ipfs
    ]);
    // get the link id if available to scroll to the correct position
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isTocEmpty) {
            const linkId = window.location.hash;
            if (linkId) router.push("/revision/".concat(ActivityId, "#").concat(linkId));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTocEmpty
    ]);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(()=>{
        setIsTocEmpty(toc.length === 0);
    }, [
        toc
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const fetchUserDataAndIncView = async ()=>{
            if (ActivityId && typeof ActivityId === "string") {
                var ref;
                const { data  } = await _store_store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch(_services_activities__WEBPACK_IMPORTED_MODULE_4__/* .getWikiCreatorAndEditorByActivityId.initiate */ .Hu.initiate(ActivityId));
                setWikiData({
                    ...wiki,
                    ...data
                });
                if (wiki) (0,_services_wikis_utils__WEBPACK_IMPORTED_MODULE_8__/* .incrementWikiViewCount */ .N)((ref = wiki.content[0]) === null || ref === void 0 ? void 0 : ref.id);
            }
        };
        fetchUserDataAndIncView();
    }, [
        ActivityId,
        wiki
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            wikiData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO_Wiki__WEBPACK_IMPORTED_MODULE_6__/* .WikiHeader */ .r, {
                slug: (ref1 = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref1 === void 0 ? void 0 : ref1.id,
                author: ((ref2 = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.author) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.profile) === null || ref4 === void 0 ? void 0 : ref4.username) || ((ref5 = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.author) === null || ref6 === void 0 ? void 0 : ref6.id) || "",
                dateModified: (ref7 = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref7 === void 0 ? void 0 : ref7.updated,
                datePublished: (ref8 = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref8 === void 0 ? void 0 : ref8.created,
                title: "".concat((ref9 = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref9 === void 0 ? void 0 : ref9.title, " - ").concat((ref11 = (ref10 = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref10 === void 0 ? void 0 : ref10.categories[0]) === null || ref11 === void 0 ? void 0 : ref11.title),
                description: (ref12 = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref12 === void 0 ? void 0 : ref12.summary,
                mainImage: (0,_utils_WikiUtils_getWikiImageUrl__WEBPACK_IMPORTED_MODULE_10__/* .getWikiImageUrl */ .A)((ref13 = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref13 === void 0 ? void 0 : ref13.images),
                noindex: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .xu, {
                mt: -2,
                children: [
                    !isLatest && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .kC, {
                        flexDir: {
                            base: "column",
                            md: "row"
                        },
                        justify: "center",
                        align: "center",
                        gap: 2,
                        bgColor: "red.200",
                        _dark: {
                            bgColor: "red.500"
                        },
                        w: "100%",
                        p: 2,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .xv, {
                                textAlign: "center",
                                children: "You are seeing an older version of this wiki."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements__WEBPACK_IMPORTED_MODULE_9__/* .LinkButton */ .Qj, {
                                href: "/wiki/".concat((ref14 = wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0]) === null || ref14 === void 0 ? void 0 : ref14.id),
                                maxW: "120px",
                                variant: "solid",
                                bgColor: "dimColor",
                                sx: {
                                    "&:hover, &:focus, &:active": {
                                        bgColor: "dimColor",
                                        textDecoration: "underline"
                                    }
                                },
                                px: 4,
                                size: "sm",
                                children: "View Latest"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Wiki_WikiPage_WikiMarkup__WEBPACK_IMPORTED_MODULE_7__/* .WikiMarkup */ .F, {
                        wiki: wikiData === null || wikiData === void 0 ? void 0 : wikiData.content[0],
                        ipfs: wikiData === null || wikiData === void 0 ? void 0 : wikiData.ipfs
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Revision);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,3874,3415,2876,5675,2192,7249,8764,5619,4095,6788,6422,4116,4235,2082,1300,6747,8283,3702,7135,8865,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Frevision%2F%5Bid%5D.tsx&page=%2Frevision%2F%5Bid%5D!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);